import {
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Inject,
  INJECTOR,
  Injector,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { InputBaseComponent } from '../../base';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-input' },
  selector: 'pulse-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent
  extends InputBaseComponent
  implements ControlValueAccessor, OnInit, DoCheck
{
  control: FormControl;
  inputType = 'text';
  isPassword = false;
  inactiveFocus = true;
  private _type = 'text';
  private _msgCustomError = '';

  @Input() activeError = true;
  @Input() label = 'Name';
  @Input() placeholder = 'Enter a value';
  @Input() hasIcon = false;
  @Input() disabled = false;
  @Input() type = 'text';
  @Input() appearance: any;
  @Input() msgRequired = 'This field is required';
  @Input() msgMinlength = 'Enter at least {requiredLength} characters';
  @Input() msgPattern = 'Invalid format';
  @Input() floatLabel:any = 'auto';

  @Output() pulseDisabledState: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  constructor(
    @Inject(INJECTOR) private injector: Injector,
    protected override el: ElementRef
  ) {
    super(el);
  }

  get msgCustomError(): string {
    return this._msgCustomError;
  }

  @Input()
  set msgCustomError(value: string) {
    this._msgCustomError = value;
  }

  ngOnInit(): void {
    const ngControl: NgControl = this.injector.get(NgControl);
    if (ngControl) {
      setTimeout(() => {
        this.control = ngControl.control as FormControl;
      });
    }
  }

  ngDoCheck(): void {}

  get errors(): boolean {
    return (
      (this.control &&
        this.control?.invalid &&
        this.control.errors &&
        (this.control.dirty || this.control.touched) &&
        this.inactiveFocus &&
        this.activeError) ||
      !!this._msgCustomError
    );
  }

  @HostListener('pulseDisabledState', ['$event'])
  handleDisabledStateEvent(value: boolean) {
    if (this.disabled !== value) {
      this.disabled = value;
    }
  }

  override setDisabledState(isDisabled: boolean): void {
    if (this.nativeInput) {
      this.nativeInput.disabled = isDisabled;
    }

    this.pulseDisabledState.emit(isDisabled);
  }

  get nativeInput(): HTMLInputElement {
    return this.el.nativeElement.querySelector('input');
  }
}
